import { createStore } from 'store-utils';
import { IPolicy } from '../types/policies-types';

export interface IPoliciesMap {
  [K: string]: IPolicy;
}

export interface IUpdatedPoliciesMap {
  [K: string]: Partial<IPolicy>;
}
interface PoliciesState {
  policies: IPoliciesMap;
  dirtyPolicies?: IUpdatedPoliciesMap;
}

const PoliciesStore = createStore<PoliciesState>(
  {
    policies: {},
    dirtyPolicies: undefined,
  },
  'Policies Store',
);

export default PoliciesStore;
